// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { useMutation } from "redux-query-react";
import * as runtime from '../runtime';
import { objectToHash } from "common/object-helper";
import { PortfolioComparisonAssociationFromJSON, PortfolioComparisonAssociationToJSON, } from '../models';
/**
 * Retrieving portfolio comparison association model via GET
 * Get portfolio comparison association by Id
 */
export function getPortfolioComparisonAssociationByIdRaw(requestParameters, requestConfig = {}) {
    if (requestParameters.id === null || requestParameters.id === undefined) {
        throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getPortfolioComparisonAssociationById.');
    }
    let queryParameters = null;
    let queryString = "";
    const headerParameters = {};
    const { meta = {} } = requestConfig;
    const config = {
        url: runtime.BASE_PATH + `/portfolio-comparison-association/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))) + queryString,
        meta,
        update: requestConfig.update || {
            PortfolioComparisonAssociation: (prevValue, transformedValue) => {
                return { ...prevValue, ...transformedValue };
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'GET',
            headers: headerParameters,
        },
        body: queryParameters,
        transform: requestConfig.transform ? requestConfig.transform : (body, text) => {
            const objResponse = PortfolioComparisonAssociationFromJSON(body);
            if (body.id) {
                return { PortfolioComparisonAssociation: { [objResponse.id]: objResponse } };
            }
            if (body.data && body.total && requestConfig.queryKey) {
                return { PortfolioComparisonAssociation: { [requestConfig.queryKey]: objResponse } };
            }
            return {};
        }
    };
    config.queryKey = requestConfig.queryKey || `GetPortfolioComparisonAssociationById-${objectToHash(requestParameters)}`;
    return config;
}
/**
* Retrieving portfolio comparison association model via GET
* Get portfolio comparison association by Id
*/
export function getPortfolioComparisonAssociationById(requestParameters, requestConfig) {
    return getPortfolioComparisonAssociationByIdRaw(requestParameters, requestConfig);
}
/**
 * Endpoint used for creating new portfolio comparison associations via POST
 * Post portfolio comparison association
 */
export function postPortfolioComparisonAssociationRaw(requestParameters, requestConfig = {}) {
    let queryParameters = null;
    let queryString = "";
    const headerParameters = {};
    headerParameters['Content-Type'] = 'application/json';
    const { meta = {} } = requestConfig;
    const config = {
        url: runtime.BASE_PATH + `/portfolio-comparison-association` + queryString,
        meta,
        update: requestConfig.update || {
            PortfolioComparisonAssociation: (prevValue, transformedValue) => {
                return { ...prevValue, ...transformedValue };
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'POST',
            headers: headerParameters,
        },
        body: PortfolioComparisonAssociationToJSON(requestParameters.portfolioComparisonAssociation),
        transform: requestConfig.transform ? requestConfig.transform : (body, text) => {
            const objResponse = PortfolioComparisonAssociationFromJSON(body);
            if (body.id) {
                return { PortfolioComparisonAssociation: { [objResponse.id]: objResponse } };
            }
            if (body.data && body.total && requestConfig.queryKey) {
                return { PortfolioComparisonAssociation: { [requestConfig.queryKey]: objResponse } };
            }
            return {};
        }
    };
    config.queryKey = requestConfig.queryKey || `PostPortfolioComparisonAssociation-${objectToHash(requestParameters)}`;
    return config;
}
/**
* Endpoint used for creating new portfolio comparison associations via POST
* Post portfolio comparison association
*/
/**
 * Mutation hook to upsert an PortfolioComparisonAssociation
 * @param customQueryConfig TypedQueryConfig options set here will override default options.
 * @returns [QueryState, RunMutation] queryState and an async call to upsert an PortfolioComparisonAssociation
 */
export const usePostPortfolioComparisonAssociation = (customQueryConfig) => {
    return useMutation((portfolioComparisonAssociation, customQueryParam) => postPortfolioComparisonAssociationRaw({ portfolioComparisonAssociation }, { ...customQueryConfig, meta: { ...customQueryConfig?.meta, ...customQueryParam } }));
};
export function postPortfolioComparisonAssociation(requestParameters, requestConfig) {
    return postPortfolioComparisonAssociationRaw(requestParameters, requestConfig);
}
